/* breakpoints */
var breakpoint_tablet = 768;
var breakpoint_desktop = 1025;

/* var. globales */
var menuContextualTop;  // top menu contextual on load

/* init. */
jQuery('document').ready(setup);
jQuery(window).on('load', documentReady);

/**
 * setup
 */
function setup() {
    initTarteAuCitron();

    /* GLOBAL : déplacement surtitre au dessus du titre */
    jQuery('.title1').each(function() {
        jQuery(this).nextAll('.subhead').insertBefore(jQuery(this));
    });

    /* Menu */
    jQuery('#block-navigationprincipale .show-submenu').on('click touch', function(evt) {
        jQuery(this).parent().toggleClass('active');
    });

    /* Menu Sticky */
    refreshMenuSticky();

    /* Menu mobile */
    jQuery('.btn-menu-mobile').on('click touch', function(evt) {
        evt.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery('#menu').toggleClass('active');
    });

    /* Btn share */
    jQuery('.share-linkedin').on('click touch', function(evt){
        evt.preventDefault();
        window.open('https://www.linkedin.com/shareArticle?mini=true&' +
            'url=' + encodeURIComponent(window.location.href) + '&' +
            'title=' + encodeURIComponent(window.location.href) + '&' +
            'source=LinkedIn',
            '_blank', 'toolbar=no, scrollbars=yes, resizable=yes, top=300, left=300, width=540, height=420');
    });

    /* FAQ */
    jQuery('.paragraph--bloc-faq dt').on('click touch', function(evt){
        evt.preventDefault();
        jQuery(this).toggleClass('expanded');
        jQuery(this).next().toggleClass('expanded');
        setTimeout('refreshMenuSticky();', 300);
    });
    jQuery('.paragraph--bloc-faq dd').on('click touch', function(evt){
        evt.preventDefault();
        jQuery(this).toggleClass('expanded');
        jQuery(this).prev().toggleClass('expanded');
        setTimeout('refreshMenuSticky();', 300);
    });

    /* paragraphe slider images */
    var slideshowImages = jQuery('.paragraph--bloc-slider-images .owl-carousel').owlCarousel({
        loop:           true,
        navText:        ['<svg class="icon"><use href="/themes/custom/cci_workin/images/sprites.svg#icone-fleche-longue"></use></svg>','<svg class="icon"><use href="/themes/custom/cci_workin/images/sprites.svg#icone-fleche-longue"></use></svg>'],
        autoplay:       false,
        autoplayTimeout:5000,
        navContainer:   '.nav-slide',
        responsive: {
            0: {
                nav:    false,
                items:  1.2,
                margin: 20,
            },
            1025: {
                nav:    true,
                items:  1,
                margin: 0,
            }
        }
    });

    /* paragraphe slider offres */
    //console.log(jQuery('.field_offres .views-element-container .owl-carousel .views-row').length);
    var slideshowOffres = jQuery('.field_offres .views-element-container .owl-carousel').owlCarousel({
        nav:            false,
        autoplay:       false,
        //autoWidth:      true,
        responsiveClass:true,
        loop:           false,
        responsive: {
            0: {
                items:      1.2,
                dots:       false,
                dotsEach:   3,
                margin:     20,
            },
            576: {
                items:      2.2,
                dots:       true,
                dotsEach:   2,
                margin:     30,
            },
            768: {
                items:      2,
                dots:       true,
                dotsEach:   2,
                margin:     30,
            },
            1025: {
                items:      3,
                dots:       true,
                dotsEach:   3,
                margin:     30,
            }
        }
    });

    /* paragraphe remontée de salles */
    var slideshowSalles = jQuery('.field_salles .wrapper').owlCarousel({
        nav:            false,
        autoplay:       false,
        //autoWidth:      true,
        responsiveClass:true,
        loop:           false,
        responsive: {
            0: {
                items:      1.2,
                dots:       false,
                dotsEach:   3,
                margin:     20,
            },
            576: {
                items:      2.2,
                dots:       true,
                dotsEach:   2,
                margin:     30,
            },
            768: {
                items:      2,
                dots:       true,
                dotsEach:   2,
                margin:     30,
            },
            1025: {
                items:      3,
                dots:       true,
                dotsEach:   3,
                margin:     30,
            }
        }
    });
    /* paragraphe remontée auto de salles */
    var slideshowSalles = jQuery('.view-display-liste-salles').addClass('owl-carousel').owlCarousel({
        nav:            false,
        autoplay:       false,
        //autoWidth:      true,
        responsiveClass:true,
        loop:           false,
        responsive: {
            0: {
                items:      1.2,
                dots:       false,
                dotsEach:   3,
                margin:     20,
            },
            576: {
                items:      2.2,
                dots:       true,
                dotsEach:   2,
                margin:     30,
            },
            768: {
                items:      2,
                dots:       true,
                dotsEach:   2,
                margin:     30,
            },
            1025: {
                items:      3,
                dots:       true,
                dotsEach:   3,
                margin:     30,
            }
        }
    });

    jQuery('.inner-teaser .content').matchHeight();

    /* paragraphe liste ambiances */
    $('.field_ambiances .views-element-container').append(
        '<div class="nav-slide">\n' +
        '    <div class="pagination">\n' +
        '        <span class="index">1</span>\n' +
        '        &nbsp;/&nbsp;\n' +
        '        <span class="count">' + $('.field_ambiances .view-display-liste-ambiances .views-row').length + '</span>\n' +
        '    </div>\n' +
        '</div>'
    );
    $('.field_ambiances .view-display-liste-ambiances .views-row').each(function (index) {
       $(this).attr('data-index', index + 1);
    });
    var slideshowAmbiances = jQuery('.field_ambiances .view-display-liste-ambiances').addClass('owl-carousel').owlCarousel({
        loop:           true,
        nav:            true,
        navContainer:   '.nav-slide',
        navText:        ['<svg class="icon"><use href="/themes/custom/cci_workin/images/sprites.svg#icone-fleche-longue"></use></svg>','<svg class="icon"><use href="/themes/custom/cci_workin/images/sprites.svg#icone-fleche-longue"></use></svg>'],
        autoplay:       false,
        //autoWidth:      true,
        responsiveClass:true,
        items:      1,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        animateOut: 'slideOutUp',
        animateIn: 'slideInUp',
        onTranslated: function (event) {
            var carousel   = $(event.target);

            var slideSelected = carousel.find('.owl-item').eq(event.item.index);
            var index = slideSelected.find('.views-row').attr('data-index');

            carousel.closest('.views-element-container').find('.nav-slide .index').text(index);
        }
    });

    /* paragraphe News'in Salorges */
    jQuery('.actualites .views-row .wrapper').matchHeight();

    /* paragraphe gallerie */
    // init Masonry
    var $grid = jQuery('.paragraph--bloc-galerie').masonry({
        //gutter: 15,
        itemSelector: '.grid-item',
        percentPosition: true,
        columnWidth: '.grid-sizer'
    });

    // phone
    jQuery('.btn-phone').on('click touch', function(evt){
        jQuery(this).toggleClass('active');
        jQuery(this).closest('.menu-contact').toggleClass('phone-unfolded')
    });

    jQuery('.field_phone').on('click touch', function(evt){
        evt.preventDefault();
        jQuery(this).addClass('active');
    });

    /* Home : modal video */
    jQuery('.open-modal-iframe').on('click touch', function(evt){
        evt.preventDefault();

        //var urlIframe = jQuery(this).attr('href').replace('https://youtu.be/', 'https://youtube.com/embed/');
        var urlIframe = jQuery(this).attr('href');

        if (urlIframe.indexOf('https://www.google.com/maps') < 0) {
          urlIframe = jQuery(this).attr('href').split('/')[4];
        }

        //jQuery('.modal .modal-content').empty().append('' + '<div class="youtube_player" videoID="' + urlIframe + '" width="100%" height="100%" theme="light" rel="0" controls="1" showinfo="0" autoplay="1"></div>');
        jQuery('.modal .modal-content').empty().append('<iframe src="' + urlIframe + '" height="100%" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

        jQuery('.modal').toggleClass('active');
        jQuery('.dialog-off-canvas-main-canvas').addClass('mask-active');
    });

    jQuery('.modal .btn-close').on('click touch', function(evt){
        evt.preventDefault();

        jQuery('.dialog-off-canvas-main-canvas').removeClass('mask-active');
        jQuery('.modal').removeClass('active');
        jQuery('.modal .modal-content').empty();
    });


    /* GLOBAL : parallax */
    var parallax = skrollr.init({forceHeight: false});
    if (parallax.isMobile()) {
        parallax.destroy();
    }

    /* refresh positions blocks  */
    refreshPositionsBlocks();

    /* GLOBAL : onresize */
    jQuery(window).resize(function(){
        refreshPositionsBlocks();
        refreshMenuSticky();
    });

    /* GLOBAL : contextual menu */
    if (jQuery('.block-contextual-links').length) {
        menuContextualTop = jQuery('.block-contextual-links').offset().top;
        jQuery('.block-contextual-links a').on('click touch', function (e) {
            e.preventDefault();
            var target = jQuery(this).attr('href');
            var topAnchor = jQuery(target).offset().top - jQuery('.header-top').outerHeight();
            if (jQuery('.block-contextual-links.sticky .contextual-links-inner').length) {
                topAnchor -= jQuery('.block-contextual-links.sticky .contextual-links-inner').outerHeight();
            }
            jQuery('html, body').stop().animate({scrollTop: topAnchor}, 400);
        });
        refreshMenuContextual();
    }

    /* GLOBAL : scroll */
    jQuery(window).scroll(function(){
        refreshMenuSticky();

        if (jQuery('.block-contextual-links').length) {
            refreshMenuContextual();
        }
    });

    /**
     *  Google Tag Manager
     */
    jQuery('.field_phone').on('click touch', function(evt) {
        gtag('event', 'clic', {'event_category': 'c-telephone','event_label': 'ct-intention-appel-ok'});
    });
    jQuery('.btn-phone').on('click touch', function(evt) {
        gtag('event', 'clic', {'event_category': 'c-telephone','event_label': 'ct-intention-appel-ok'});
    });
    jQuery('.link-linkedin').on('click touch', function(evt) {
        gtag('event', 'reseaux-sociaux', {'event_category': 'liens-sortants','event_label': 'linkedin'});
    });
    jQuery('.link-twitter').on('click touch', function(evt) {
        gtag('event', 'reseaux-sociaux', {'event_category': 'liens-sortants','event_label': 'twitter'});
    });
    jQuery('.link-instagram').on('click touch', function(evt) {
        gtag('event', 'reseaux-sociaux', {'event_category': 'liens-sortants','event_label': 'instagram'});
    });
}

/**
 * documentReady
 */
function documentReady() {
}

/**
 * refreshMenuSticky
 */
var makeMenuSticky = false;
function refreshMenuSticky() {
    var withContextualLinks = (jQuery('.block-contextual-links').length);

    /* pour version tablet & desktop uniquement */
    if (jQuery('body').hasClass('home')) {
        if (jQuery(window).width() >= breakpoint_desktop) {
            makeMenuSticky = (jQuery(window).scrollTop() > 120);
        }
        else {
            var makeMenuSticky = false;
        }
    }
    else {
        makeMenuSticky = true;
    }


    if (makeMenuSticky) {
        if (!jQuery('.header-top').hasClass('sticky')) {
            jQuery('.header-top').addClass('sticky');
        }
        if (!jQuery('.menu-contact').hasClass('sticky')) {
            jQuery('.menu-contact').addClass('sticky');
        }

        /* position fixe sauf si scroll après le bloc "stay'in live" */
        if (jQuery('.paragraph--stay-in-live').length) {

            var posTopBLocStayInLive = jQuery('.paragraph--stay-in-live').offset().top;
            var scrollTopBottom = jQuery(window).scrollTop() + jQuery(window).outerHeight();
            //console.log(scrollTopBottom + '>=' + posTopBLocStayInLive);

            if (scrollTopBottom >= posTopBLocStayInLive && !withContextualLinks) {
                //jQuery('.menu-contact').css('top', (posTopBLocStayInLive - jQuery('.menu-contact').outerHeight()) + 'px');
                //jQuery('.menu-contact').css('position', 'absolute');

                if (!jQuery('.menu-contact').hasClass('sticky-stop')) {
                    jQuery('.menu-contact').insertBefore(jQuery('.paragraph--stay-in-live'));
                    jQuery('.menu-contact').addClass('sticky-stop');
                }
            }
            else {
                //jQuery('.menu-contact').css('top', '');
                //jQuery('.menu-contact').css('position', '');

                if (jQuery('.menu-contact').hasClass('sticky-stop')) {
                    jQuery('.menu-contact').insertAfter(jQuery('.why-choose'));
                    jQuery('.menu-contact').removeClass('sticky-stop');
                }
            }
        }

        // si présence du menu de liens contextuels : celui-ci remplace le header au scroll
        if (withContextualLinks) {
            // fusion menus sticky contact + contextual-links
            if (!jQuery('.menu-contact').hasClass('with-contextual-links')) {
                jQuery('.menu-contact').prepend(jQuery('.block-contextual-links'));
                jQuery('.menu-contact').addClass('with-contextual-links');
            }

            if ((jQuery(window).scrollTop() + jQuery(window).outerHeight() >= jQuery(window).outerHeight() * 1.5)) {
                jQuery('.header-top').addClass('hidden');

                // affichage menu sticky
                jQuery('.menu-contact.with-contextual-links').addClass('visible');
            }
            else {
                jQuery('.header-top').removeClass('hidden');

                jQuery('.menu-contact.with-contextual-links').removeClass('visible');

            }
        }
    }
    else {
        jQuery('.menu-contact').css('top', '');
        jQuery('.menu-contact').css('position', '');

        if (jQuery('.header-top').hasClass('sticky')) {
            jQuery('.header-top').removeClass('sticky');
        }
        if (jQuery('.menu-contact').hasClass('sticky')) {
            jQuery('.menu-contact').removeClass('sticky');
        }
    }
}

/**
 * refreshPositionsBlocks
 */
function refreshPositionsBlocks() {
    /* version mobile */
    if (jQuery(window).width() < breakpoint_desktop) {
        if (!jQuery('.links-mobile-top').length) {
            jQuery('#menu .links-mobile').prepend('<ul class="links-mobile-top"></ul>');
            jQuery('.menu-contact .contact').appendTo('.links-mobile-top');
            jQuery('.menu-contact .quotation').appendTo('.links-mobile-top');
            jQuery('.menu-contact .phone').appendTo('.links-mobile-top');
        }
    }
    /* version tablet + desktop */
    else {
        jQuery('.links-mobile-top .contact').appendTo('.menu-contact');
        jQuery('.links-mobile-top .quotation').appendTo('.menu-contact');
        jQuery('.links-mobile-top .phone').appendTo('.menu-contact');
        jQuery('.links-mobile-top').remove();
    }
}

/**
 * refreshMenuContextual
 */
function refreshMenuContextual() {
    /*if (!jQuery('.menu-contact').hasClass('with-contextual-links')) {
        jQuery('.menu-contact').prepend(jQuery('.block-contextual-links'));
        jQuery('.menu-contact').addClass('with-contextual-links');
    }*/

    jQuery('.item-contextual-link a').each(function () {
        if (isScrolledIntoView(jQuery('#' + jQuery(this).attr('id').replace('item-', '')))) {
            jQuery('.item-contextual-link a').removeClass('active');
            jQuery(this).addClass('active');
        }
    });
}

/**
 * isScrolledIntoView
 */
function isScrolledIntoView(elem){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = elem.offset();
    bounds.right = bounds.left + elem.outerWidth();
    bounds.bottom = bounds.top + elem.outerHeight();

    return (!(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top + win.height() / 10 ||
        viewport.top > bounds.bottom
    ));
}

function initTarteAuCitron() {
    tarteaucitron.init({
      "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
      "DenyAllCta" : true, /* Show the deny all button */
      "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
      "highPrivacy": true, /* désactiver le consentement implicite (en naviguant) ? */
      "orientation": "middle", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
      "showAlertSmall": false, /* afficher le petit bandeau en bas à droite ? */
      "closePopup": false, /* Show a close X on the banner */
      "showIcon": false, /* Show cookie icon to manage cookies */
      "adblocker": false, /* Show a Warning if an adblocker is detected */
      "removeCredit": true, /* supprimer le lien vers la source ? */
      "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
      "moreInfoLink": true, /* Show more info link */
      "readmoreLink": "", /* Change the default readmore link */
      "gaTimeout":800
    });

    // matomo cloud
    tarteaucitron.user.matomoId = 6;
    tarteaucitron.user.matomoHost = 'https://ccinantes.matomo.cloud/';
    tarteaucitron.user.matomoCustomJSPath = 'https://cdn.matomo.cloud/ccinantes.matomo.cloud/matomo.js';
    (tarteaucitron.job = tarteaucitron.job || []).push('matomocloud');
}
